// extracted by mini-css-extract-plugin
export default {"colorCircle":"color-label__colorCircle___NEmkt","colorName":"color-label__colorName___EGpBG","active":"color-label__active___j0ztO"};